import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "../../football/fragments/fragment-summary";

export default class FlagPatKick extends Fragment {
    constructor(kickedBy) {
        super();

        this.patType = "K";
        this.kickedBy = kickedBy;

        this.requiredData = [
            {
                name: "kickedBy",
                type: FragmentDataType.Player,
                displayName: "Kicked By",
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.kickedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `${stringifier.firstInitial(this.kickedBy)} ${
            summaryContext.patPoints
        }-point kick attempt`;
        return new FragmentSummary(message);
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            kickedBy: playerReducer(this.kickedBy)
        };
    }
}
